import React, { useState } from 'react';
import { PenLine } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '../components/ui/popover';
import { Textarea } from '../components/ui/textarea';
import { commsApi } from './phase567Api';
import { errorMessage } from './errors';

export const SIGNATURE_MAX = 1000;

// Ticket 195: a person's own email signature. Plain text, theirs alone, empty
// until they write one; the composer puts it at the bottom of a new email.
export default function SignatureEditor({ signature, onSaved }) {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState(signature);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const save = async () => {
    setSaving(true);
    setError('');
    try {
      const r = await commsApi.setSignature(text);
      onSaved(r.signature);
      setOpen(false);
    } catch (e) {
      setError(errorMessage(e, 'Could not save the signature'));
    } finally { setSaving(false); }
  };

  return (
    <Popover open={open} onOpenChange={(v) => { setOpen(v); if (v) { setText(signature); setError(''); } }}>
      <PopoverTrigger asChild>
        <button type="button" data-testid="signature-open"
          className="inline-flex items-center gap-1 text-[11px] text-slate-500 hover:text-slate-800">
          <PenLine size={11} /> {signature ? 'Edit signature' : 'Add signature'}
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-72 p-3" data-testid="signature-popover">
        <label htmlFor="signature-text" className="text-xs font-medium text-slate-700">Your email signature</label>
        <Textarea id="signature-text" value={text} onChange={(e) => setText(e.target.value)} rows={4}
          maxLength={SIGNATURE_MAX} className="mt-1 text-sm" data-testid="signature-text" />
        {error && <p className="text-xs text-red-600 mt-1" role="alert" data-testid="signature-error">{error}</p>}
        <div className="flex justify-end gap-2 mt-2">
          <button type="button" onClick={() => setOpen(false)} className="text-xs text-slate-500">Cancel</button>
          <button type="button" onClick={save} disabled={saving} data-testid="signature-save"
            className="text-xs px-3 py-1 rounded-md text-white disabled:opacity-50" style={{ background: '#070B5F' }}>
            Save
          </button>
        </div>
      </PopoverContent>
    </Popover>
  );
}
